import styles from "./CategoryBar.module.css";
import sub_no_name from "../../../../assets/images/icons/sub-no-name.png";
import { ReactComponent as BackIcon } from "../../../../assets/svg/bottom-arrow.svg";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { getMetadataValueByKey } from "../../../../base/utils";
import Loading from "../../Loading/Loading";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";
import { useState } from "react";

const StyledDiv = styled.div`
  order: ${(props) => props.order};
`;

export default function Cat({ categories, depth, loading }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const slugList = searchParams.get("cat")?.split(",") || [];
  const [activeCat, setActiveCat] = useState(slugList[depth]);
  const navigate = useLangNavigate();
  const { t, i18n } = useTranslation();

  if (loading) {
    return (
      <div className={styles.Loading}>
        <Loading />
      </div>
    );
  }

  if (slugList[depth] !== slugList[slugList.length - 1]) {
    return (
      <Cat
        categories={
          categories.find(
            (cat) => cat.id === slugList[depth] || cat.name === "sales",
          )?.sub_categories || []
        }
        depth={depth + 1}
      />
    );
  }

  return (
    <>
      <div className={`${styles.ParentListContainer}`}>
        <div className={styles.ParentList}>
          <div className={styles.ParentItems}>
            {categories
              .filter((cat) => cat.products_count > 0 || cat.name == "sales")
              .map((pitem) => {
                return (
                  <StyledDiv
                    key={pitem.id}
                    className={`${styles.ParentItem} ${
                      pitem.id === slugList[slugList.length - 1] ||
                      pitem.name === slugList[slugList.length - 1]
                        ? styles.Active
                        : ""
                    }`}
                    onClick={() => {
                      setActiveCat(pitem.id);
                      setSearchParams(
                        (prev) => {
                          let slugQueries = prev.get("cat");
                          let slugParamsList = slugQueries.split(",");
                          if (pitem.name === "sales") {
                            slugParamsList.splice(
                              slugParamsList.length - 1,
                              1,
                              pitem.name,
                            );
                            prev.set("cat", slugParamsList.join(","));
                          } else {
                            if (slugQueries) {
                              slugParamsList.splice(
                                slugParamsList.length - 1,
                                1,
                                pitem.id,
                              );
                              prev.set("cat", slugParamsList.join(","));
                            } else {
                              prev.set("cat", pitem.id);
                            }
                          }
                          return prev;
                        },
                        { replace: true },
                      );
                    }}
                    order={getMetadataValueByKey(pitem.metadata, "priority")}
                  >
                    {i18n.language !== "en" && pitem.translation
                      ? pitem.translation
                      : pitem.name}
                  </StyledDiv>
                );
              })}
          </div>
        </div>
      </div>
      <div
        className={`${styles.SubListContainer} ${
          depth !== 0 ? styles.HasReturn : ""
        }`}
      >
        <div className={`${styles.SubList}`}>
          {depth !== 0 && (
            <div key="All" className={styles.SubItem} id={activeCat}>
              <div className={`${styles.SubItemImageContainer}`}>
                <img
                  alt="All"
                  src={sub_no_name}
                  className={styles.SubItemImage}
                />
              </div>
              <span className={`${styles.SubItemText} ${styles.Active}`}>
                {t("common.all")}
              </span>
            </div>
          )}
          {categories
            .find((cat) => cat.id === slugList[depth])
            ?.sub_categories.filter(
              (cat) => cat.products_count > 0 || cat.name == "sales",
            )
            .map((subItem) => {
              return (
                <StyledDiv
                  key={subItem.id}
                  className={`${styles.SubItem}`}
                  onClick={() => {
                    const preUrlSearchParams = new URLSearchParams();
                    const slugQueries = searchParams.get("cat");
                    let slugParamsList = slugQueries.split(",");
                    if (subItem.name === "sales") {
                      slugParamsList.push(subItem.name);
                      preUrlSearchParams.set("cat", slugParamsList.join(","));
                    } else {
                      if (slugQueries) {
                        slugParamsList.push(subItem.id);
                        preUrlSearchParams.set("cat", slugParamsList.join(","));
                      } else {
                        preUrlSearchParams.set("cat", slugList[0]);
                      }
                    }
                    navigate(`/category/?${preUrlSearchParams.toString()}`);
                  }}
                  order={getMetadataValueByKey(subItem.metadata, "priority")}
                >
                  <div className={`${styles.SubItemImageContainer}`}>
                    <img
                      alt={subItem.name}
                      src={subItem.image ? subItem.image : sub_no_name}
                      className={styles.SubItemImage}
                    />
                  </div>
                  <span
                    className={`${styles.SubItemText} ${
                      subItem.id === slugList[depth + 1] ? styles.Active : ""
                    }`}
                  >
                    {i18n.language === "ar" && subItem.translation
                      ? subItem.translation
                      : subItem.name}
                  </span>
                </StyledDiv>
              );
            })}
          {depth !== 0 && (
            <div
              onClick={() => {
                navigate(-1);
              }}
              className={`${styles.BackContainer} ${styles.Active}`}
            >
              <BackIcon
                className={styles.BottomArrow}
                style={{
                  rotate: i18n.dir() === "ltr" ? "90deg" : "-90deg",
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
